import { frontendURL } from 'dashboard/helper/URLHelper';

const IvrAudiosList = () => import('../telephony/pages/ivr/IvrAudiosList.vue');
const IvrBuilder = () => import('../telephony/pages/ivr/IvrBuilder.vue');

const meta = {
  permissions: ['administrator'],
};

const whatsappCallingRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/whatsapp-calling/ivr'),
      name: 'whatsapp_calling_ivr',
      meta: { ...meta, platform: 'whatsapp_calling' },
      component: IvrAudiosList,
    },
    {
      path: frontendURL('accounts/:accountId/whatsapp-calling/ivr/builder'),
      name: 'whatsapp_calling_ivr_builder_new',
      meta: { ...meta, platform: 'whatsapp_calling' },
      component: IvrBuilder,
    },
    {
      path: frontendURL(
        'accounts/:accountId/whatsapp-calling/ivr/builder/:flowId'
      ),
      name: 'whatsapp_calling_ivr_builder_edit',
      meta: { ...meta, platform: 'whatsapp_calling' },
      component: IvrBuilder,
      props: route => ({ flowId: route.params.flowId }),
    },
  ],
};

export default whatsappCallingRoutes;
